import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlaneTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPaperPlaneTopRight"><Path d="M7.93261 10.856L0.509766 3H23.5591L11.7473 23.1539L8.67416 12.16L15.6298 8.29084L14.9007 6.97999L7.93261 10.856Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlaneTopRight;
